// @ts-nocheck
import * as effects from 'redux-saga/effects';
import { wsActions } from '../../actions';
import { handleError } from '../../../handleError';
import { getNowDateTimeIso } from '../../../../utils/dateTime';
import { chatActions } from '../../../chat/actions';

export function* handleMessageText(payload) {
  try {
    yield effects.put(wsActions.setSocketsStatus('MESSAGE'));
    const date = yield effects.call(getNowDateTimeIso);
    const message = {
      id: payload.message_id,
      text: payload.token,
      user_id: 'jessankocomtr',
      created_at: date,
      chat_id: payload.chat_id,
      nextToken: payload.next_token,
      tokenIndex: payload.token_index,
    };
    if (payload.token_index === 0) {
      yield effects.put(chatActions.setMessageId(payload.id));
      yield effects.put(chatActions.createMessage(message));
      // TODO: add message to store
    } else {
      yield effects.put(chatActions.updateMessage(message));
      // TODO: update message in store
    }
    yield effects.put(chatActions.debounceChat(payload.next_token));
  } catch (e) {
    yield handleError(e);
  }
}
